exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".exerciseTile{overflow:hidden}.exerciseTile .activityTitle,.exerciseTile .responseBody,.exerciseTile .tileImg{padding:10px}.exerciseTile.clickableElement{cursor:zoom-in}.exerciseTile.clickableElement:hover{opacity:.7!important}.exerciseTile .responseInfo .responseHeader{position:relative}.exerciseTile .responseInfo .activityTitle{margin-bottom:0;border-bottom:1px solid #ddd}.exerciseTile .responseInfo .activityTitle.narrow{padding-right:20px;padding-left:20px}.exerciseTile .responseInfo .bookTitle{margin-bottom:5px}.exerciseTile .responseInfo .removeButton{position:absolute;right:4px;top:4px;padding:0;font-size:15px;outline:none;color:#999}.exerciseTile .responseInfo .removeButton:hover{color:#555}.exerciseTile .imgContainer.small{max-height:150px}.exerciseTile .date{display:block;position:relative;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/activities/exercise_tile.scss
// module id = 1466
// module chunks = 0